import { MachineActions } from 'common/bento/types/MachineConfig';

import assertEventType from '../../../../../common/bento/lib/assertEventType';
import { logEvent } from '../../../../Analytics/analytics';
import { createToast } from '../../../../Bento/atoms';
import locales from '../locales';
import { ManageBeneficiaryViews } from '../pages/ManageBeneficiary';
import { Model } from './model';

export enum Action {
  DisplaySuccessfullyDeletedBeneficiaryToast = 'displaySuccessfullyDeletedBeneficiaryToast',
  DisplaySuccessfullySubmittedBeneficiaryFormToast = 'displaySuccessfullySubmittedBeneficiaryFormToast',
  ViewManageBeneficiaryEvent = 'viewManageBeneficiaryEvent',
}

const actions: MachineActions<Model, Action> = {
  displaySuccessfullyDeletedBeneficiaryToast: (context, event) => {
    assertEventType(event, 'done.invoke.deleteBeneficiary');
    createToast({
      status: 'success',
      title: locales.formatString(
        event.data.gender === 'male'
          ? locales.deletedMaleBeneficiary
          : locales.deletedFemaleBeneficiary,
        {
          name: event.data.name,
        },
      ),
    });
  },

  displaySuccessfullySubmittedBeneficiaryFormToast: (context, event) => {
    assertEventType(event, 'done.invoke.submitBeneficiaryForm');

    const title =
      event.data.view === 'create'
        ? locales.formatString(
            event.data.gender === 'male'
              ? locales.addedMaleBeneficiary
              : locales.addedFemaleBeneficiary,
            {
              name: event.data.name,
            },
          )
        : locales.updatedBeneficiary;

    createToast({
      status: 'success',
      title,
    });
  },

  viewManageBeneficiaryEvent: (context, event) => {
    assertEventType(event, 'GO_MANAGE_BENEFICIARY');

    const name =
      event.data.view === ManageBeneficiaryViews.Create
        ? 'Onboarding Beneficiary List Person Added'
        : 'Onboarding Beneficiary List Edit Pressed';

    logEvent({
      name,
      properties: {
        newDesign: true,
      },
      usePrefix: false,
    });
  },
};

export default actions;
